export const pageAnimation = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.25,
      duration: 0.5,
      when: "beforeChildren",
    },
  },
  exit: {
    opacity: 0,
    transition: { ease: "easeOut", duration: 0.5 },
  },
};

export const titleAnim = {
  hidden: { y: 200 },
  show: {
    y: 0,
    transition: {
      duration: 0.75,
      ease: "easeOut",
    },
  },
};

export const waveAnim = {
  hidden: { pathLength: 0, pathOffset: 1 },
  show: {
    pathLength: 1,
    pathOffset: 0,
    transition: {
      duration: 1,
    },
  },
};

export const fade = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { type: "tween", ease: "easeOut", duration: 1.2, delay: 1.2 },
  },
};

export const photoAnim = {
  hidden: { scale: 1.5, opacity: 0 },
  show: {
    scale: 1,
    opacity: 1,
    transition: {
      type: "tween",
      ease: "easeOut",
      duration: 1.2,
      delay: 1.2,
    },
  },
};

export const lineAnimStarter = {
  hidden: { width: "0%" },
  show: {
    width: "100%",
    transition: { duration: 1.2, delay: 1.2 },
  },
};
export const lineAnim = {
  hidden: { width: "0%" },
  show: {
    width: "100%",
    transition: { duration: 1},
  },
};

export const slider = {
  hidden: { x: "-130%", skew: "45deg" },
  show: {
    x: "100%",
    skew: "0deg",
    transition: { type: "tween", ease: "easeOut", duration: 1 },
  },
};
export const sliderContainer = {
  hidden: {
    opacity: 1,
  },
  show: {
    opacity: 1,

    transition: {
      staggerChildren: 0.15,
      ease: "easeOut",
      duration: 1,
    },
  },
};

export const scrollReveal = {
  hidden: { opacity: 0, scale: 0.9, transition: { duration: 1 } },
  show: {
    opacity: 1,
    scale: 1,
    transition: { type: "tween", ease: "easeOut", duration: 1 },
  },
};

export const movieContainer = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      ease: "easeOut",
      duration: 0.75,
      when: "beforeChildren",
    },
  },
};
